import set from "@rill/set";
import { getSessionValue } from "../../../utils/session-helper";
import ImportProgram from "./import-program";

const importProgramController = (app) => {
  app
    .use(set("heading", ["Admin", "Import Program"]))
    .get("/import-program", ({ locals, res, session }) => {
      locals.importResult = getSessionValue(session, "adminImportProgram");
      res.body = <ImportProgram />;
    })
    // Linked with `download`, so the browser fetches it directly (rill skips
    // download links) and saves the coach's library for Claude.
    .get("/import-program/library", async ({ api, req, res }) => {
      const email = req.query.coachEmail || "";
      let data;
      try {
        const response = await api(
          `admin-coach-library?email=${encodeURIComponent(email)}`
        );
        data = await response.json();
      } catch (err) {
        // the api helper throws on a non-ok response; answer with JSON so the
        // page can show the message instead of saving an error page
        res.headers["Content-Type"] = "application/json; charset=utf-8";
        res.status = err.status ?? 500;
        res.body = JSON.stringify({
          error: {
            message:
              err.name === "HttpError"
                ? err.message
                : "Could not load the library",
          },
        });
        return;
      }

      res.headers["Content-Type"] = "application/json; charset=utf-8";
      const filename = `${data.coachEmail.replace(/[^\w.@-]/g, "_")}-library.json`;
      res.headers["Content-Disposition"] = `attachment; filename="${filename}"`;
      res.body = JSON.stringify(data, null, 2);
    });
};

export default importProgramController;
